import { render, staticRenderFns } from "./CreateV2.vue?vue&type=template&id=01af1c7c"
import script from "./CreateV2.vue?vue&type=script&lang=js"
export * from "./CreateV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports